import { MaterialRequestFormValues } from './type';

export const initialValuesForm: MaterialRequestFormValues = {
  reqDate: '',
  requestTypeId: 1,
  mrFor: null,
  requiredOn: '',
  currency: 0,
  headerDesc: '',
  remarks: '',
  ccTypeId: null,
  ccId: null,
  compId: null,
  approverNo: 0,
  statusId: 0,
  createdBy: 0,
  createdOn: '',
  updatedBy: 0,
  updatedOn: '',
  purchaseOfficer: null,
  referenceReqId: 0,
  bsPrNo: 0,
  warrantyTypeId: null,
  warrantyEndDate: '',
  warrantyPeriod: 0,
  hostName: '',
  receiveStoreId: null,
  lastActionDate: '',
  plantEngineer: 0,
  plantWorkshopManager: 0,
  itRefReqId: 0,
  emergencyPurchase: false,
};
